import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { showElement, hideElement } from "@grindex-common/helpers/domManipulation";
import { $elementChild } from "@grindex-common/helpers/elements";

const SELECTOR_NON_EXCLUSIVE_FIELDS = ".common-section";

const SELECTOR_CLEAR_FACETS_BUTTON = ".clear-facets-btn";
const SELECTOR_CLOSE_PANEL_TRIGGERS = ".close-panel, [xyl-element='narrow-search']";
const SELECTOR_COUNTRY_TOGGLE = "[data-purpose='location-country-toggle']";
const SELECTOR_DISTANCE_FILTERS = ".distance-filtering-filter";
const SELECTOR_DISTANCE_UNIT = "#radiusunit";
const SELECTOR_ERROR_MESSAGE = "#error-message-text";
const SELECTOR_ERRORS = "input.error, select.error";
const SELECTOR_FACETS_CONTAINER = ".facet-container";
const SELECTOR_GREY_CONTENT_AREA = ".gray-content-area";
const SELECTOR_LEAD_FILTERS = ".lead-filtering-filter";
const SELECTOR_MARKET_DROPDOWN = "#market";
const SELECTOR_MESSAGE_FIELD = "h3.message";
const SELECTOR_MESSAGE_SPAN = "h3.message span";
const SELECTOR_QUERY_FIELD = "#query";
const SELECTOR_RANGE_CHECKBOX = ".range-checkbox";
const SELECTOR_REDIRECTION_TEXT = ".redirectionText";
const SELECTOR_RESET_FILTERS_LINK = "a.resetFilters";
const SELECTOR_SEARCH_BUTTONS = ".search-btn";
const SELECTOR_SEARCH_FACETS = ".search-facets";
const SELECTOR_SEARCH_RESULTS_CONTAINER = ".searchResultsContainer";
const SELECTOR_SELECTS = "select";
const SELECTOR_SUBMIT = ".submit";
const SELECTOR_VALIDATION_ERROR_MSG = ".validation-error-msg";
const SELECTOR_ZIP_INPUT = "#zip";

const ELEMENT_TOGGLE_BUTTON = "btn-holder";

const CLASS_ERROR = "error";

export default class FindALocationBlockDom extends DomElementsBase {
	constructor($module) {
		const selectors = [
			SELECTOR_LEAD_FILTERS,
			SELECTOR_DISTANCE_FILTERS,
			SELECTOR_MESSAGE_FIELD,
			SELECTOR_MESSAGE_SPAN,
			SELECTOR_VALIDATION_ERROR_MSG,
			SELECTOR_MARKET_DROPDOWN,
			SELECTOR_ERROR_MESSAGE,
			SELECTOR_SELECTS,
			SELECTOR_CLEAR_FACETS_BUTTON,
			SELECTOR_COUNTRY_TOGGLE,
			SELECTOR_QUERY_FIELD,
			SELECTOR_SEARCH_FACETS,
			SELECTOR_SUBMIT,
			SELECTOR_RANGE_CHECKBOX,
			SELECTOR_REDIRECTION_TEXT,
			SELECTOR_CLOSE_PANEL_TRIGGERS,
			SELECTOR_RESET_FILTERS_LINK,
			SELECTOR_SEARCH_RESULTS_CONTAINER,
			SELECTOR_ERRORS,
			SELECTOR_ZIP_INPUT,
			SELECTOR_DISTANCE_UNIT,
			SELECTOR_FACETS_CONTAINER,
		];

		super($module, selectors);
	}

	getDistanceUnitElement() {
		return this.getElement(SELECTOR_DISTANCE_UNIT);
	}

	getNonExclusiveFields() {
		return this.getElements(SELECTOR_NON_EXCLUSIVE_FIELDS);
	}

	getZipInput() {
		return this.getElement(SELECTOR_ZIP_INPUT);
	}

	getSearchResultsContainer() {
		return this.getElement(SELECTOR_SEARCH_RESULTS_CONTAINER);
	}

	getResetFiltersLink() {
		return this.getElement(SELECTOR_RESET_FILTERS_LINK);
	}

	getRedirectionTextElement() {
		return this.getElement(SELECTOR_REDIRECTION_TEXT);
	}

	getRangeCheckBox() {
		return this.getElement(SELECTOR_RANGE_CHECKBOX);
	}

	getSubmitButton() {
		return this.getElement(SELECTOR_SUBMIT);
	}

	getSearchFacets() {
		return this.getElement(SELECTOR_SEARCH_FACETS);
	}

	getFacetsContainer() {
		return this.getElement(SELECTOR_FACETS_CONTAINER);
	}

	getQueryField() {
		return this.getElement(SELECTOR_QUERY_FIELD);
	}

	getCountryToggle() {
		return this.getElement(SELECTOR_COUNTRY_TOGGLE);
	}

	getCountryToggleButton() {
		return $elementChild(this.getCountryToggle(), ELEMENT_TOGGLE_BUTTON);
	}

	getClearFacetsButton() {
		return this.getElement(SELECTOR_CLEAR_FACETS_BUTTON);
	}

	getSearchButtons() {
		return this.getElements(SELECTOR_SEARCH_BUTTONS);
	}

	getLeadFilters() {
		return this.getElements(SELECTOR_LEAD_FILTERS);
	}

	getMessageField() {
		return this.getElement(SELECTOR_MESSAGE_FIELD);
	}

	getMessageSpan() {
		return this.getElement(SELECTOR_MESSAGE_SPAN);
	}

	getValidationMessageElement() {
		return this.getElements(SELECTOR_VALIDATION_ERROR_MSG);
	}

	getClosePanelTriggerElements() {
		return this.getElements(SELECTOR_CLOSE_PANEL_TRIGGERS);
	}

	getGreyContentArea() {
		return document.querySelector(SELECTOR_GREY_CONTENT_AREA);
	}

	setMessageText(text) {
		this.getMessageSpan().innerHTML = text;
	}

	setRedirectionText(text) {
		this.getRedirectionTextElement().innerHTML = text;
	}

	showError(message) {
		showElement(this.getValidationMessageElement());
		this.getElement(SELECTOR_ERROR_MESSAGE).innerText = message;
	}

	showGreyContentArea() {
		showElement(this.getGreyContentArea());
	}

	showExclusiveTerritoriesFilters() {
		this.getLeadFilters().forEach(($filter) => {
			showElement($filter);
		});
	}

	showRegularFields() {
		this.getNonExclusiveFields().forEach(($filter) => {
			showElement($filter);
		});
	}

	showSearchButton() {
		this.getSearchButtons().forEach(($searchButton) => {
			showElement($searchButton);
		});
	}

	showResetLink() {
		showElement(this.getResetFiltersLink());
	}

	showMessageField() {
		showElement(this.getMessageField());
	}

	hideResetLink() {
		this.hideElement(this.getResetFiltersLink());
	}

	hideElement($element) {
		if ($element) {
			hideElement($element);
		}
	}

	hideElements($elements) {
		$elements.forEach(($element) => {
			hideElement($element);
		});
	}

	hideEverything() {
		// hideElement(this.getGreyContentArea());

		this.hideElements(this.getLeadFilters());

		this.hideElements(this.getNonExclusiveFields());
	}

	toggleFacetsContainer() {
		if (this.getFacetsContainer()) {
			this.getFacetsContainer().classList.toggle("open");
		}
	}

	clearErrors() {
		this.getElements(SELECTOR_ERRORS, true).forEach(($error) => {
			$error.classList.remove(CLASS_ERROR);
		});
	}

	clearValidation() {
		this.hideElement(this.getValidationMessageElement());
		this.clearErrors();
	}

	isHidden($element) {
		if (!$element) {
			return true;
		}

		return $element.parentElement.classList.contains("hidden") || $element.style.display === "none";
	}

	setToRedirectMode(redirectData) {
		showElement(this.getRedirectionTextElement());
		this.hideElements(this.getSearchButtons());
		this.setRedirectionText(redirectData);
		this.hideEverything();
	}

	addNotApplicableToDropdown(dropdown) {
		if (dropdown._$element.options[1] && dropdown._$element.options[1].value > -1) {
			const $option = document.createElement("option");
			$option.text = "Not Applicable";
			$option.value = -1;
			dropdown._$element.options.add($option, 1);
		}
	}

	getDistanceUnit() {
		const $unit = this.getDistanceUnitElement();
		const isDefault = $unit.checked ? "" : "default-";

		return {
			value: $unit.getAttribute(isDefault + "value"),
			label: $unit.getAttribute(isDefault + "label"),
		};
	}

	disableSubmitButtons() {
		this.getSearchButtons().forEach(($btn) => {
			$btn.classList.add("disabled");
		});
	}

	enableSubmitButtons() {
		this.getSearchButtons().forEach(($btn) => {
			$btn.classList.remove("disabled");
		});
	}
}
